import {UserModel} from "interfaces";

export const userInitialState: UserModel = {
  id: "",
  name: "",
  email: "",
  status: 1,
  verified: 1,
  updated_at: "",
  created_at: "",
  remember_token: null,
  email_verified_at: null,
};
